import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {LignePaiement} from '../../models/paiement/LignePaiement';
import {PaiementNonAffecte} from '../../models/paiement/PaiementNonAffecte';
import {Paiement} from '../../models/paiement/Paiement';

@Injectable({
    providedIn: 'root'
})
export class PaiementService {

    private baseUrl = `${environment.paiement_url.replace(/\/$/, '')}/api`;
    constructor(private http: HttpClient) {}

    createPaiement(paiement: Paiement): Observable<Paiement> {
        const url = `${this.baseUrl}/paiements`;
        return this.http.post<Paiement>(url, paiement);
    }

    getPaiementById(id: number): Observable<Paiement> {
        return this.http.get<Paiement>(`${this.baseUrl}/paiements/${id}`);
    }

    getPaiements(): Observable<Paiement[]> {
        return this.http.get<Paiement[]>(`${this.baseUrl}/paiements`);
    }

    getPaiementsByDocumentId(documentId: number): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/paiements/document/${documentId}`);
    }

    updatePaiement(id: number, paiement: Paiement): Observable<Paiement> {
        const url = `${this.baseUrl}/paiements/${id}`;
        return this.http.put<Paiement>(url, paiement);
    }
}

